module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst productAttributes = model.productAttributes || {}\n// TODO: id permissions\n%><div>\n<h1><%= storage.__('product.manualPromptAssociations.promptChooser.productDetails.title') %></h1>\n<table>\n<tbody>\n<tr>\n<td><%= storage.__('product.manualPromptAssociations.promptChooser.productDetails.productID') %>:</td>\n<td><%= productAttributes.productID %></td>\n</tr>\n</tbody>\n<tbody>\n<tr>\n<td><%= storage.__('product.manualPromptAssociations.promptChooser.productDetails.number') %>:</td>\n<td><%= productAttributes.number %></td>\n</tr>\n</tbody>\n<tbody>\n<tr>\n<td><%= storage.__('product.manualPromptAssociations.promptChooser.productDetails.name') %>:</td>\n<td><%= productAttributes.name %></td>\n</tr>\n</tbody>\n</table>\n</div>"
  , __filename = "components/templates/mblx/products/promptAssociations/promptChooser/productDetails.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const productAttributes = model.productAttributes || {}
// TODO: id permissions

    ; __line = 4
    ; __append("<div>\n<h1>")
    ; __line = 5
    ; __append(escapeFn( storage.__('product.manualPromptAssociations.promptChooser.productDetails.title') ))
    ; __append("</h1>\n<table>\n<tbody>\n<tr>\n<td>")
    ; __line = 9
    ; __append(escapeFn( storage.__('product.manualPromptAssociations.promptChooser.productDetails.productID') ))
    ; __append(":</td>\n<td>")
    ; __line = 10
    ; __append(escapeFn( productAttributes.productID ))
    ; __append("</td>\n</tr>\n</tbody>\n<tbody>\n<tr>\n<td>")
    ; __line = 15
    ; __append(escapeFn( storage.__('product.manualPromptAssociations.promptChooser.productDetails.number') ))
    ; __append(":</td>\n<td>")
    ; __line = 16
    ; __append(escapeFn( productAttributes.number ))
    ; __append("</td>\n</tr>\n</tbody>\n<tbody>\n<tr>\n<td>")
    ; __line = 21
    ; __append(escapeFn( storage.__('product.manualPromptAssociations.promptChooser.productDetails.name') ))
    ; __append(":</td>\n<td>")
    ; __line = 22
    ; __append(escapeFn( productAttributes.name ))
    ; __append("</td>\n</tr>\n</tbody>\n</table>\n</div>")
    ; __line = 26
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/mblx/products/promptAssociations/promptChooser/productDetails.ejs

}